import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../Button';
import { IAuthAction, IAuthHeader } from './AuthHeader.types';
import KaaboPrimaryLogo from '../../../../assets/images/kaabo-primary-logo.svg';

import AuthHeaderStyle from './AuthHeader.module.scss';

const authActions: Record<string, IAuthAction> = {
  '/login': {
    instruction: "Don't have an account?",
    buttonTitle: 'Sign Up',
    navigatePath: '/get-started'
  },
  '/get-started': {
    instruction: 'Already have an account?',
    buttonTitle: 'Login',
    navigatePath: '/'
  }
};

const AuthHeader = ({ className, activityBarStyles }: IAuthHeader) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const renderAuthActions = (path: string) => {
    const action = authActions[path];

    if (!action) {
      return null;
    }
    return (
      <>
        <p className={AuthHeaderStyle.authHeader__authInstruction}>{action.instruction}</p>
        <Button
          className={AuthHeaderStyle.authHeader__authInstructionBtn}
          title={action.buttonTitle}
          color="primary"
          type="button"
          onPress={() => navigate(action.navigatePath)}
        />
      </>
    );
  };

  return (
    <div className={`${AuthHeaderStyle.authHeader} ${className}`}>
      <div className={`${AuthHeaderStyle.authHeader__activityBar} ${activityBarStyles}`}>
        <span className={AuthHeaderStyle.authHeader__left}>
          <span className={AuthHeaderStyle.authHeader__primaryLogo}>
            <img src={KaaboPrimaryLogo} alt="Kaabo Primary Logo" width="109px" />
          </span>
        </span>

        <span className={AuthHeaderStyle.authHeader__right}>{renderAuthActions(pathname)}</span>
      </div>
    </div>
  );
};

export default AuthHeader;
